import React, { useEffect, useState } from "react";
import AuthCard from "../../shared/components/CustomCards";
import { InputNumber } from "primereact/inputnumber";
import PrimaryButton from "../../shared/components/CustomButtons";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomInputNumber, CustomOtpNumber } from "../../shared/components/AllInputs";
import formValidation from "../../utils/validations";
import { showFormErrors } from "../../utils/commonFunctions";
import { useDispatch } from "react-redux";
import {
  requestOTPAction,
  verifyOTPAction,
} from "../../store/actions/auth.actions";

export default function VerificationCode() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userData = location.state;
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState(
    userData.otpType === 1
      ? {
        email: userData.email,
        fullName: userData.fullName,
        password: userData.password,
        confirmPassword: userData.confirmPassword,
        otpType: userData.otpType,
        otp: "",
      }
      : {
        email: userData.email,
        otpType: userData.otpType,
        otp: "",
      }
  );

  useEffect(() => {
    if (!userData) navigate("/auth/login");
  }, [navigate, userData]);

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const resendCode = () => {
    data.otp = null;
    dispatch(requestOTPAction(data, setLoading, () => null));
  };

  const handleVerify = () => {
    if (showFormErrors(data, setData)) {
      dispatch(verifyOTPAction(data, setLoading, navigate));
      
    }
  };

  return (
    <div className="flex justify-content-center align-items-center h-full">
      <AuthCard heading={"Verification Code"}>
        <p className="text-base text-center heading">
          Enter the 6-digit verification code sent to {userData.email}
        </p>
        <CustomOtpNumber
          placeholder="Otp"
          name="otp"
          data={data}
          extraClassName="p-0"
          col={12}
          onChange={handleChange}
          className="w-full"
          maxLength={6}
          label={"Otp"}
        />

        <PrimaryButton
          label="Submit"
          extraClassNames="w-full mt-3"
          onClick={handleVerify}
          loading={loading}
        />
        <p
          className="text-sm font-semibold text-center mt-5 primary-color cursor-pointer"
          onClick={resendCode}
        >
          Resend code
        </p>
      </AuthCard>
    </div>
  );
}
